import React from 'react';

import styles from './GoldenSettingsLabelInfo.module.scss';

interface IGoldenSettingsLabelInfoProps {
	importFileName?: string | null;
	date?: string | null;
	emptyText?: string;
}

const GoldenSettingsLabelInfo = ({
	date,
	importFileName,
	emptyText = 'Golden Settings are not set',
}: IGoldenSettingsLabelInfoProps) => {
	const labelColorClass = date || importFileName ? styles.configExists : styles.configNotExists;

	return (
		<div className={styles.labelWrapper}>
			<span className={labelColorClass}>
				{!date && !importFileName
					? emptyText
					: importFileName
						? `${importFileName} is set as Golden Settings`
						: `${date} Configuration is set as Golden Settings`}
			</span>
		</div>
	);
};

export default GoldenSettingsLabelInfo;
